export default __webpack_public_path__ + "images/603e570fee0e779e33d3349b9b3d1eab-2_mobile_659x494.jpg";